import { FormReviewData } from "@/types";
import { formatDate, formatActivities } from "@/utils/formatters";

interface TripDetailsSectionProps {
  formData: FormReviewData;
}

export function TripDetailsSection({ formData }: TripDetailsSectionProps) {
  const trip = formData?.tripDetails;
  if (!trip) return null;

  const tripDuration = Math.ceil(
    (new Date(trip.returnDate).getTime() -
      new Date(trip.departureDate).getTime()) /
      (1000 * 60 * 60 * 24)
  );

  return (
    <div className="info-card trip-info">
      <h3>Trip Details</h3>
      <div
        className="info-grid"
        style={{ display: "flex", flexDirection: "column", gap: "16px" }}
      >
        <div
          className="info-item grid grid-cols-1 sm:grid-cols-[200px_1fr] gap-4 pb-3 border-b border-gray-200"
        >
          <label style={{ fontWeight: "700", color: "#374151" }}>
            Departure Date:
          </label>
          <span style={{ color: "#1f2937" }}>
            {formatDate(trip.departureDate)}
          </span>
        </div>
        <div
          className="info-item grid grid-cols-1 sm:grid-cols-[200px_1fr] gap-4 pb-3 border-b border-gray-200"
        >
          <label style={{ fontWeight: "700", color: "#374151" }}>
            Return Date:
          </label>
          <span style={{ color: "#1f2937" }}>
            {formatDate(trip.returnDate)}
          </span>
        </div>
        <div
          className="info-item grid grid-cols-1 sm:grid-cols-[200px_1fr] gap-4"
        >
          <label style={{ fontWeight: "700", color: "#374151" }}>
            Trip Duration:
          </label>
          <span style={{ color: "#1f2937" }}>{tripDuration} days</span>
        </div>
      </div>

      {trip.destinations && trip.destinations.length > 0 && (
        <div className="destinations-section">
          <h4>Itinerary ({trip.destinations.length} destinations)</h4>
          <div className="destinations-list">
            {trip.destinations
              .sort((a, b) => a.order - b.order)
              .map((dest, index) => (
                <div key={index} className="destination-card">
                  <div className="destination-header">
                    <div
                      style={{
                        display: "flex",
                        gap: "4px",
                        alignItems: "center",
                      }}
                    >
                      <span className="destination-order">#{dest.order}</span>
                      <span className="destination-location">
                        {dest.destination_city
                          ? `${dest.destination_city}, `
                          : ""}
                        {dest.destination_country}
                      </span>
                    </div>
                    <span className="destination-duration">
                      {dest.days_in_location} days
                    </span>
                  </div>
                  <div className="destination-activities">
                    <strong>Activities:</strong>{" "}
                    {formatActivities(dest.activities)}
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
    </div>
  );
}
